/* ********************* request 全局配置文档 ************************/
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ResponseData } from '@/type'
import { ElMessageBox, ElMessage } from 'element-plus'
import store from './store'
let lastTimmer = 0
const isOtherApp = () => {
  try {
    if (window.top === window) {
      return false
    } else {
      return true
    }
  } catch (e) {
    return true
  }
}
const statusCode : { [key: string ]: string} = {
  400: '请求错误，请联系IT报事',
  401: '当前用户未授权，请您重新登录',
  403: '您暂无权限查看该页面',
  404: '未找到该页面',
  408: '请求超时',
  500: '服务正忙，请您稍后再试',
  501: '服务正忙，请您稍后再试',
  502: '服务正忙，请您稍后再试',
  503: '服务正忙，请您稍后再试',
  504: '服务正忙，请您稍后再试',
  505: '服务正忙，请您稍后再试'
}
const errorFn = (err: any) => {
  if (err.toString().indexOf('timeout') !== -1) {
    console.error('请求超时，请稍后再试')
  }
  if (err?.response) {
    err.message = statusCode[err.response?.status] || '请求失败，请稍后再试'
    const thisTimer = new Date().getTime()
    if (thisTimer - lastTimmer > 5000) {
      ElMessage.error({
        message: err.message,
        type: 'error',
        duration: 1500
      })
      lastTimmer = thisTimer
    }
  }
  return Promise.reject(err)
}
/* ***此处开始封装不同后台下的axios实例 ****/
const service = axios.create({
  headers: {},
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 80000,
  withCredentials: true
})
service.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => {
    if (config.url && config.url.indexOf('excel-server') >= 0) {
      if (!config.headers.Authorization) {
        config.headers.Authorization = store.state.docAuth.data.token
      }
    }
    if (config.url && config.url.includes('kongfuzi-currency-server')) {
      config.headers['X-Gaia-Api-Key'] = process.env.VUE_APP_CURRENCY_API_KEY
    }
    // 任务服务
    if (config.url && config.url.includes('/taskServerApi')) {
      config.headers['x-gaia-api-key'] = process.env.VUE_APP_TASK_URL_API_KEY
      // 线上环境使用网关地址
      config.baseURL = process.env.VUE_APP_TASK_URL
      config.url = config.url.replace('/taskServerApi', '')
    }
    if (config.method === 'get') {
      if (config.url && config.url.indexOf('?') < 0) {
        config.url += '?r=' + new Date().getTime()
      } else {
        config.url += '&r=' + new Date().getTime()
      }
    }
    // 请求发出时，添加到cancelTokenArr中
    config.cancelToken = new axios.CancelToken(cancelFn => {
      store.commit('addCancelToken', {
        cancel: cancelFn,
        url: config.url
      })
    })
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response: AxiosResponse): Promise<AxiosResponse<any>> => {
    // 处理返回体
    Object.assign(response, response.data)
    const result: ResponseData = response
    const code = Number(result.code)
    if (code === 5011) {
      ElMessageBox.confirm('您的权限已过期，请刷新页面', '', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        window.location.reload()
      })
    } else if (code === 3002 || code === 50008 || code === 50012 || code === 50014 || code === 302) {
      if (isOtherApp()) {
        window.parent.postMessage({ messageType: 'loginStateChange', loginState: false }, '*')
      } else {
        if (result.loginUrl) {
          window.location.href = result.loginUrl
        }
      }
    }
    return Promise.resolve(response)
  }, errorFn
)
export default service
